<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="135.887" height="66.479" viewBox="0 0 135.887 66.479">
    <g transform="translate(1.393 1)">
      <g transform="translate(-1074 -504)">
        <path class="a"
              d="M10.5,4H78.456a8.31,8.31,0,0,1,8.5,8.06V60.419a8.31,8.31,0,0,1-8.5,8.06H10.5A8.31,8.31,0,0,1,2,60.419V12.06A8.31,8.31,0,0,1,10.5,4Z"
              transform="translate(1072 500)"/>
        <path class="a" d="M86.951,6,44.476,35.733,2,6" transform="translate(1072 506.495)"/>
      </g>
      <line class="b" x2="40.043" transform="translate(93.451 15.5)"/>
      <line class="b" x2="20" transform="translate(93.451 49.5)"/>
      <line class="b" x2="31" transform="translate(93.451 32.5)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "MailIconLg"
}
</script>

<style scoped>
.a, .b {
  fill: none;
  stroke: #57b98f;
  stroke-linecap: round;
  stroke-width: 2px;
}

.a {
  stroke-linejoin: round;
}
</style>
